import React, { useState } from 'react';

const TruncatedText = ({ text, maxLength = 250 }) => {
  const [showMore, setShowMore] = useState(false);

  const truncatedText = () => {
    if (text?.length <= maxLength) {
      return text;
    }

    const lastSpaceIndex = text.lastIndexOf(' ', maxLength);
    return showMore ? text : text.slice(0, lastSpaceIndex) + '...';
  };

  const showLessText = text.length <= maxLength * 1.5 ? 'hidden' : 'flex';

  return (
    <span>
      <span dangerouslySetInnerHTML={{ __html: truncatedText() }}></span>{' '}
      {!showMore && text.length > maxLength ? (
        <span className="underline cursor-pointer text-a-blue" onClick={() => setShowMore(true)}>
          More
        </span>
      ) : (
        <span
          className={`${showLessText} text-a-blue underline cursor-pointer`}
          onClick={() => setShowMore(false)}
        >
          Less
        </span>
      )}
    </span>
  );
};

export default TruncatedText;
